<template>
    <section class="text-gray-700 body-font">
         <div class=" px-5 py-24 mx-auto flex flex-wrap items-center md:px-24">
            <div class="w-full hidden md:block md:h-2"></div>
            <div class="hidden md:block lg:w-3/5 md:w-1/3 md:pr-16 lg:pr-0 pr-0">
                <img class="absolute hidden top-0 right-0 z-0 opacity-50 p-16 md:relative md:block w-1/2 my-auto md:p-8 md:opacity-20 lg:p-24" src="@/assets/cios-dress.svg" />
            </div>
            <div class="lg:w-2/6 md:w-2/3 bg-primary bg-opacity-10 rounded-lg p-8 flex flex-col md:mx-auto w-full mt-10 md:mt-0">
                <h2 class="text-center text-gray-900 text-lg font-medium title-font mb-5">Registrate</h2>
                <input class="bg-white rounded border border-gray-400 focus:outline-none focus:border-indigo-500 text-base px-4 py-2 mb-4" placeholder="Email" type="text" v-model="username" :class="nohabilitado">
                <input class="bg-white rounded border border-gray-400 focus:outline-none focus:border-indigo-500 text-base px-4 py-2 mb-4" placeholder="Contraseña" type="password" v-model="password" :class="nohabilitado">
                <p class="text-xs mt-3 flex">confirma tu contraseña</p>
                <input class="bg-white rounded border border-gray-400 focus:outline-none focus:border-indigo-500 text-base px-4 py-2 mb-4" placeholder="Contraseña" type="password" v-model="cpassword" :class="nohabilitado">
                <button class="text-secondary bg-primary border-0 py-2 px-8 focus:outline-none hover:bg-opacity-75 rounded text-lg" @click="signupreq" :class="nohabilitado">Enviar</button>
                <a v-if="cargando">cargando...</a>
                <p class="text-xs mt-3 flex" v-if="error">{{error}} <span class="material-icons my-auto mx-1 text-sm">report</span> </p>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import firebase from 'firebase'
export default {
    data() {
        return {
            username: '',
            password: '',
            cpassword: ''
        }
    },
    computed: {
        ...mapGetters([
            'loading',
            'getError'
        ]),
        cargando() {
            return this.loading
        },
        error(){
            return this.getError
        },
    },
    methods: {
        ...mapMutations([
            'setLoading',
            //'showMessage',
            'setAuthenticated',
            'log_user'
        ]),
        signupreq() {
            if(this.cpassword == this.password && this.password != ''){
                this.setLoading(true)
                return firebase.auth().createUserWithEmailAndPassword(this.username, this.password)
                    .then((response) => {
                        //this.showMessage({ content: 'Usuario Creado!', color: 'success' })
                        this.log_user(response.user.uid)
                        localStorage.user_id = response.user.uid
                        this.setLoading(false)
                        this.setAuthenticated(true)
                        //this.$router.push({ path: '/dashboard' })
                        this.$store.commit('showMessage', { content: 'Registrado exitosamente!', color: 'info' })
                    })
                    .catch((error) => {
                        //this.showMessage({ content: error, color: 'primary' })
                        this.setLoading(false)
                        this.$store.commit('setError', error)
                        this.$store.commit('showMessage', { content: error, color: 'info' })
                    })
            }else{
                this.$store.commit('showMessage', { content: 'Las contraseñas no coinciden!', color: 'info' })
            }
        }
    }
}
</script>

